import { createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import {
  getStickerInput,
  stickerResponse,
} from "../../domain/model/qrResponseModel";
import { gql } from "@apollo/client";

export const getSticker = createAsyncThunk(
  "request/query/getSticker",
  async (config: getStickerInput, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    const { query, variables } = gqlBuilder.query({
      operation: "getMultipleStickers",
      variables: {
        type: { value: config.type, required: true },
        ids: { value: config.ids, required: true, type: "[ID!]" },
      },
      fields: ["pdfUrl"],
    });

    try {
      return (await client.query(
        "getMultipleStickers",
        gql(query),
        variables,
      )) as stickerResponse;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
